import { gql } from 'graphql-tag'

import { BREAKOUT_SESSION_MANAGE_BANNER_SESSION } from '@/components/Series/Banners/BreakoutSessionBanner/internal/BreakoutSessionManageBanner.hasura'

export const MANAGE_BREAKOUT_SESSIONS_SUBSCRIPTION = gql`
  subscription ManageBreakoutSessions($sessionId: Int!) {
    session_by_pk(id: $sessionId) {
      ...BreakoutSessionManageBannerSession
    }
  }

  ${BREAKOUT_SESSION_MANAGE_BANNER_SESSION}
`
